/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  agendas: null,
  upcomingIDs: null,
  currentAgendaID: null,
  currentAgendaItemIndex: null,
  currentHeaderItemIndex: null,
  modalActive: false,
  autoFetchComments: true,
  autoFetchCommentsTimeout: 15000,
  loaders: {
    comment: false,
    agendas: false,
  },
  initialized: false,
};

// getters
const getters = {
  member_id: (state, getters, rootState, rootGetters) => rootGetters['main/member_id'],
  memberName: (state, getters, rootState, rootGetters) => rootGetters['main/memberName'],
  currentUserName: (state, getters, rootState, rootGetters) => rootGetters['main/currentUserName'],
  fuelUserID: (state, getters, rootState, rootGetters) => rootGetters['main/fuelEmployee'] ? rootGetters['auth/user']['user_id'] : null,
  portalUserID: (state, getters, rootState, rootGetters) => !rootGetters['main/fuelEmployee'] ? rootGetters['auth/user']['portal_user_id'] : null,
  contactID: (state, getters, rootState, rootGetters) => !rootGetters['main/fuelEmployee'] ? rootGetters['auth/user']['contact_id'] : null,
  attendeeID: (state, getters, rootState, rootGetters) => rootGetters['main/meetingAttendee'] ? rootGetters['main/attendee_id'] : null,
  agendas: (state) => state.agendas,
  upcomingIDs: (state) => state.upcomingIDs,
  upcomingAgendas: (state) => lodash.filter(state.agendas, (agenda) => state.upcomingIDs.includes(agenda.id)),
  autoFetchComments: (state) => state.autoFetchComments,
  autoFetchCommentsTimeout: (state) => state.autoFetchCommentsTimeout,
  initialized: (state) => state.initialized,
  loaders: (state) => state.loaders,
  modalActive: (state) => state.modalActive,
  currentAgendaItemComments: (state, getters) => getters.currentAgenda.hasOwnProperty('comments') ? lodash.filter(getters.currentAgenda.comments, comment => comment.item_id === getters.currentAgendaItem.id) : [],
  currentAgendaItemIndex: (state) => state.currentAgendaItemIndex,
  currentHeaderItemIndex: (state) => state.currentHeaderItemIndex,
  currentAgenda: (state) => lodash.find(state.agendas, { id: state.currentAgendaID }),
  currentAgendaItems: (state, getters) => getters.currentAgenda.hasOwnProperty('agenda_items') ? getters.currentAgenda.agenda_items : [],
  currentHeaderItem: (state, getters) => getters.currentAgenda && state.currentHeaderItemIndex !== null
    ? getters.currentAgendaItems[state.currentHeaderItemIndex] : null,
  currentAgendaItem: (state, getters) => getters.currentAgenda && state.currentAgendaItemIndex !== null
    ? getters.currentAgendaItems[state.currentAgendaItemIndex] : null,
  fuelUserIDs: (state, getters) => getters.currentAgenda.hasOwnProperty('fuelUserIDs') && getters.currentAgenda.fuelUserIDs ? getters.currentAgenda.fuelUserIDs : [],
  contactIDs: (state, getters) => getters.currentAgenda.hasOwnProperty('contactIDs') && getters.currentAgenda.contactIDs ? getters.currentAgenda.contactIDs : [],
  fuelUserAttendeeIDs: (state, getters) => getters.currentAgenda.hasOwnProperty('fuel_user_attendee_ids') && getters.currentAgenda.fuel_user_attendee_ids ? getters.currentAgenda.fuel_user_attendee_ids : [],
  fuelUserAttendeesList: (state, getters) => lodash.filter(getters.fuelUsersList, (fuelUser) => getters.fuelUserAttendeeIDs.includes(fuelUser.id)),
  contactAttendeeIDs: (state, getters) => getters.currentAgenda.hasOwnProperty('contact_attendee_ids') && getters.currentAgenda.contact_attendee_ids ? getters.currentAgenda.contact_attendee_ids : [],
  contactAttendeesList: (state, getters) => lodash.filter(getters.contactsList, (contact) => getters.contactAttendeeIDs.includes(contact.id)),
  otherAttendeesList: (state, getters) => getters.currentAgenda.other_attendees,
  fuelUsersList: (state, getters) => getters.currentAgenda.hasOwnProperty('users') ? getters.currentAgenda.users : [],
  contactsList: (state, getters) => getters.currentAgenda.hasOwnProperty('contacts') ? getters.currentAgenda.contacts : [],
  titleTransforms: () => ([
    {
      value: 'Qa Preview',
      transform: 'QA Preview',
    },
    {
      value: 'Qa Approval',
      transform: 'QA Approval',
    },
    {
      value: 'Qa Approved',
      transform: 'QA Approved',
    },
    {
      value: 'Sem',
      transform: 'SEM',
    },
    {
      value: 'Seo',
      transform: 'SEO',
    },
    {
      value: 'Seo Sem Rep Management',
      transform: 'SEO/SEM/Rep Management',
    },
    {
      value: 'Seo Sem Rep Management Edit',
      transform: 'SEO/SEM/Rep Management Edit',
    },
    {
      value: 'Seo Hold',
      transform: 'SEO Hold',
    },
  ]),
  glyphs: () => ([
    { status: 'marketing', icon: 'random' },
    { status: 'digital', icon: 'equalizer' },
    { status: 'human resources', icon: 'user' },
    { status: 'professional development', icon: 'leaf'},
    { status: 'finance and operations', icon: 'stats' },
    { status: 'software development', icon: 'floppy-disk' },
    { status: 'strategic supplier', icon: 'tower' },
  ]),
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  activateModal({ commit, getters }, payload) {
    const headerIndex = lodash.findLastIndex(getters.currentAgendaItems, (agendaItem) => agendaItem.type === 'HeaderItem', payload);
    commit('SET_PROPERTY', { key: 'currentHeaderItemIndex', value: headerIndex });
    commit('SET_PROPERTY', { key: 'currentAgendaItemIndex', value: payload });
    commit('SET_PROPERTY', { key: 'modalActive', value: true });
  },

  closeModal({ commit }) {
    commit('SET_PROPERTY', { key: 'modalActive', value: false });
    commit('SET_PROPERTY', { key: 'currentHeaderItemIndex', value: null });
    commit('SET_PROPERTY', { key: 'currentAgendaItemIndex', value: null });
  },

  nextItem({ commit, dispatch, getters }) {
    commit('SET_PROPERTY', { key: 'currentAgendaItemIndex', value: (state.currentAgendaItemIndex + 1) });
    if (getters.currentAgendaItem.type === 'HeaderItem') {
      commit('SET_PROPERTY', { key: 'currentHeaderItemIndex', value: state.currentAgendaItemIndex });
      dispatch('nextItem');
    }
  },

  prevItem({ commit, dispatch, getters }) {
    commit('SET_PROPERTY', { key: 'currentAgendaItemIndex', value: (state.currentAgendaItemIndex - 1) });
    if (getters.currentAgendaItem.type === 'HeaderItem') {
      const headerIndex = lodash.findLastIndex(getters.currentAgendaItems, (agendaItem) => agendaItem.type === 'HeaderItem', this.currentAgendaItemIndex - 1);
      commit('SET_PROPERTY', { key: 'currentHeaderItemIndex', value: headerIndex });
      dispatch('prevItem');
    }
  },

  submitComment({ commit, dispatch, getters }, payload) {
    commit('TOGGLE_LOADING', { key: 'comment', value: true });
    return axios.post(`${CONFIG.get('BASE_URL')}/api/meeting-agendas/submitComment/`, qs.stringify({
      agenda_id: getters.currentAgenda.id,
      item_id: getters.currentAgendaItem.id,
      fuel_user_id: getters.fuelUserID,
      portal_user_id: getters.portalUserID,
      contact_id: getters.contactID,
      attendee_id: getters.attendeeID,
      note: payload,
      agenda_title: getters.currentAgenda.title,
      item_title: getters.currentAgendaItem.title,
      practice_id: getters.member_id,
      practice_name: getters.memberName,
    }))
      .then((response) => {
        dispatch('flash/addMessage', { text: 'Comment Saved' }, { root: true });
        commit('ADD_COMMENT', response.data);
        commit('TOGGLE_LOADING', { key: 'comment', value: false });
      }).catch((err) => {
        dispatch('flash/addMessage', { text: 'Error Saving Comment', type: 'error' }, { root: true });
      });
  },

  /**
   * Loads Meeting Agendas
   */
  getAgendas({ commit, state }) {
    if (!state.initialized) {
      commit('TOGGLE_LOADING', { key: 'agendas', value: true });
      return axios.get(`${CONFIG.get('BASE_URL')}/api/meeting-agendas/getMeetingAgendas/`)
        .then((response) => {
          commit('SET_PROPERTY', { key: 'agendas', value: response.data.agendas });
          commit('SET_PROPERTY', { key: 'upcomingIDs', value: response.data.upcoming });
          commit('SET_PROPERTY', { key: 'initialized', value: true });
          commit('TOGGLE_LOADING', { key: 'agendas', value: false });
        }).catch((err) => {
          this.handleErrorResponse(err);
        });
    }
  },

  /**
   * Loads authorized meeting agenda
   */
  getAgenda({ commit, state }) {
    if (!state.initialized) {
      commit('TOGGLE_LOADING', { key: 'agendas', value: true });
      return axios.get(`${CONFIG.get('BASE_URL')}/api/meeting-agendas/getMeetingAgenda/`)
        .then((response) => {
          commit('SET_PROPERTY', { key: 'agendas', value: response.data.agendas });
          commit('SET_PROPERTY', { key: 'upcomingIDs', value: response.data.upcoming });
          commit('SET_PROPERTY', { key: 'initialized', value: true });
          commit('TOGGLE_LOADING', { key: 'agendas', value: false });
        }).catch((err) => {
          this.handleErrorResponse(err);
        });
    }
  },

  fetchComments({ commit, dispatch, state, getters }) {
    return axios.get(`/api/meeting-agendas/getComments/${state.currentAgendaID}/`)
      .then((response) => {
        if (response.data.length > getters.currentAgenda.comments.length) {
          commit('SET_AGENDA_COMMENTS', { agendaID: state.currentAgendaID, comments: response.data });
          dispatch('flash/addMessage', { text: 'New Comments Retrieved' }, { root: true });
        }
      }).catch((error) => {
        console.log(error);
        dispatch('flash/addMessage', { text: 'Error Retrieving Comments', type: 'error' }, { root: true });
      });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  ADD_COMMENT(state, payload) {
    const agendaIndex = lodash.findIndex(state.agendas, { id: state.currentAgendaID })
    if (state.agendas[agendaIndex].hasOwnProperty('comments')) {
      state.agendas[agendaIndex]['comments'].push(payload);
    } else {
      state.agendas[agendaIndex]['comments'] = [payload];
    }
  },
  SET_AGENDA_COMMENTS(state, payload) {
    const agendaIndex = lodash.findIndex(state.agendas, { id: payload.agendaID });
    state.agendas[agendaIndex].comments = payload.comments;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
